import * as tslib_1 from "tslib";
import { orchestrator } from 'satcheljs';
import { startDomainEnroll } from '../actions/startDomainEnroll';
import { traceCreateEmailButtonClick } from '../utils/domainOptionTracer';
import { hideFullOptions } from 'owa-options-orchestration';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { PremiumDomainConnectFirstStep } from 'owa-domain-connect';
export default orchestrator(startDomainEnroll, function createEmail() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            traceCreateEmailButtonClick();
            hideFullOptions();
            mountDomainConnectSecondStep();
            return [2 /*return*/];
        });
    });
});
function mountDomainConnectSecondStep() {
    var dcSecondStepContainer = document.createElement('div');
    document.body.appendChild(dcSecondStepContainer);
    ReactDOM.render(React.createElement(PremiumDomainConnectFirstStep, { onClose: function () { return document.body.removeChild(dcSecondStepContainer); } }), dcSecondStepContainer);
}
//# sourceMappingURL=startDomainEnroll.js.map